import React, { useEffect, useState } from "react";
import axios from "axios";
import { useWorkshop } from "../Common/WorkshopContext";
import { addCustomer, getCustomersForWorkshop, updateCustomer } from "../../Api/Api";
import { useNavigate } from "react-router-dom";
import CreateJobCardModal from "../Jobcard/Createjobcard";
import { FaCashRegister, FaEdit, FaHistory, FaPlus, FaTrash, FaWrench, FaSearch } from "react-icons/fa";
import AddEditCustomerModal from "./AddEditCustomer";
import Pagination from "../Pagination/Pagination";
import LoanModal from "../Loan/LoanModal";
import { useNotification } from "../Notification/NotificationContext";
import AssetAssignModal from "../Asset/AssetAssignModal";
import CreateJobCardModal2 from "../Jobcard/Createjobcard2";

const CustomerPage = () => {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ id: "", name: "", contact: "" });
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editingCustomerId, setEditingCustomerId] = useState(null);
    const { workshopId } = useWorkshop();
    const navigate = useNavigate();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const { showNotification } = useNotification();

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10;
    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const response = await getCustomersForWorkshop(workshopId, pageSize, currentPage, searchTerm);
            setCustomers(response.data.content);
            setTotalPages(response.data.totalPages);
            setTotalCount(response.data.totalElements)
        } catch (err) {
            showNotification( err.message || "Error fetching customers","error" );
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchCustomers();
    }, [workshopId, currentPage, searchTerm]);


    useEffect(() => {
        fetchCustomers();
    }, [workshopId, currentPage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        try {
            if (isEditing) {
                formData.id = editingCustomerId;
                await updateCustomer(workshopId, formData);
                showNotification("Customer Updated Successfully", "success");
            } else {
                await addCustomer(workshopId, formData);
                showNotification("Customer Added Successfully", "success");
            }
            setShowModal(false);
            setFormData({ id: "", name: "", contact: "" });
            setEditingCustomerId("");
            fetchCustomers();
        } catch (error) {
            showNotification(error.message, "error");
        }
    };

    const handleEdit = (customer) => {
        setIsEditing(true);
        setEditingCustomerId(customer.id);
        setFormData({ name: customer.name, phone: customer.phone, address: customer.address });
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`/api/customers/${id}`);
            fetchCustomers();
        } catch (error) {
            showNotification(error.message, "error");
        }
    };

    const handleAddJobCard = (customer) => {
        setSelectedCustomerId(customer.id);
        setShowCreateModal(true);
    };

    const handleJobCardCreateCloseModal = () => {
        setShowCreateModal(false)
    }

    return (
        <div className="mt-6">
            <div className="max-w-screen-xl mx-auto">
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="bg-teal-400 text-white p-4 rounded-t-lg flex flex-col sm:flex-row justify-between gap-4 items-center">
                        <h2 className="text-xl font-semibold">Customers</h2>
                        <div className="flex gap-2 items-center w-full sm:w-auto">
                            <div className="relative w-full sm:w-64">
                                <input
                                    type="text"
                                    placeholder="Search by name or contact..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-10 pr-4 py-2 rounded-md focus:outline-none text-gray-700"
                                />
                                <FaSearch className="absolute left-3 top-2.5 text-gray-400" />
                            </div>
                            <button
                                className="bg-white text-teal-500 px-4 py-2 rounded-md flex items-center hover:bg-gray-200"
                                onClick={() => {
                                    setIsEditing(false);
                                    setFormData({ id: "", name: "", contact: "",address: "" });
                                    setShowModal(true);
                                }}
                            >
                                <FaPlus className="mr-2" />
                                Add Customer
                            </button>
                        </div>
                    </div>
                    <div className="p-6">
                        {loading ? (
                            <div className="flex justify-center items-center space-x-2">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-400"></div>
                            </div>
                        ) : (
                            <>
                                <div className="overflow-x-auto shadow-md rounded-lg">
                                    <table className="min-w-full bg-white">
                                        <thead className="bg-gray-50 text-gray-800">
                                        <tr>
                                            <th className="p-3 text-left">ID</th>
                                            <th className="p-3 text-left">Name</th>
                                            <th className="p-3 text-left">Contact</th>
                                            <th className="p-3 text-left">Address</th>
                                            <th className="p-3 text-left">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {customers?.map((customer) => (
                                            <tr key={customer.id} className="border-b hover:bg-gray-100">
                                                <td className="p-3">{customer.id}</td>
                                                <td className="p-3">{customer.name}</td>
                                                <td className="p-3">{customer.phone}</td>
                                                <td className="p-3">{customer.address}</td>
                                                <td className="p-3 flex flex-wrap gap-2">
                                                    <button
                                                        className="bg-yellow-400 text-white px-3 py-1 rounded-md flex items-center hover:bg-yellow-500"
                                                        onClick={() => handleEdit(customer)}
                                                    >
                                                        <FaEdit />
                                                        <span className="ml-2">Edit</span>
                                                    </button>
                                                    <button
                                                        className="bg-red-400 text-white px-3 py-1 rounded-md flex items-center hover:bg-red-500"
                                                        onClick={() => handleDelete(customer.id)}
                                                    >
                                                        <FaTrash />
                                                        <span className="ml-2">Delete</span>
                                                    </button>
                                                    <button
                                                        className="bg-blue-400 text-white px-3 py-1 rounded-md flex items-center hover:bg-blue-500"
                                                        onClick={() =>
                                                            navigate(`/customers/${customer.id}/workshops/${workshopId}/profile`)
                                                        }
                                                    >
                                                        <FaHistory />
                                                        <span className="ml-2">Profile</span>
                                                    </button>
                                                    <button
                                                        className="bg-green-400 text-white px-3 py-1 rounded-md flex items-center hover:bg-green-500"
                                                        onClick={() => handleAddJobCard(customer)}
                                                    >
                                                        <FaWrench />
                                                        <span className="ml-2">Job Card</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="flex justify-start mt-4">

                                    <Pagination
                                        totalPages={totalPages}
                                        onPageChange={setCurrentPage}
                                        currentPage={currentPage}
                                        totalCount={totalCount}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <CreateJobCardModal2
                show={showCreateModal}
                customerId={selectedCustomerId}
                handleClose={handleJobCardCreateCloseModal}
            />
            <AddEditCustomerModal
                formData={formData}
                handleClose={() => setShowModal(false)}
                show={showModal}
                editingCustomerId={editingCustomerId}
                isEditing={isEditing}
                handleSubmit={handleSubmit}
                handleInputChange={handleInputChange}
            />
        </div>
    );
};

export default CustomerPage;
